<template >
    <div class="container" :style="overlayBgStyle">
        <div class="closeButtons">
            <q-btn icon="close" flat round dense @click="$emit('closeCarousel3D')"/>
            <ReturnHomeButton @click="$emit('closeAllDialogs')" />
        </div>
        <div class="content">
            <div style="margin-left: 1%">
                <q-btn round class="previous-button" size="lg" icon="arrow_back_ios_new">
                </q-btn>
            </div>

            <div class="scene">
                <div class="carousel">
                    <div class="carousel__cell" v-for="(resource, index) in resources" :key="index">
                        <div class="image-container">
                            <img v-bind:src="resource" @load="handleImageLoad" @click="openZoom(resource)" style="cursor: pointer;" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modal de zoom -->
            <div v-if="showZoom" class="zoom-modal" @click="closeZoom">
                <div class="zoom-content" @click.stop>
                    <q-btn icon="close" flat round dense class="close-zoom-btn" @click="closeZoom"/>
                    <img :src="zoomedImage" class="zoomed-image" />
                </div>
            </div>
            <div style="margin-right: 1%">
                <q-btn round class="next-button" size="lg" icon="arrow_forward_ios_new"></q-btn>
            </div>
        </div>
    </div>
</template>
  
<script>
import axios from 'axios';
import { ref, onMounted } from 'vue';
import ReturnHomeButton from './ReturnHomeButton.vue';
import { useOverlayBg } from '../composables/useOverlayBg';

export default {
    name: 'CubeCarousel',
    components: { ReturnHomeButton },
    props: ['blockDatas'],
    setup(props) {
        const resources = ref([]);
        const showZoom = ref(false);
        const zoomedImage = ref('');

        const openZoom = (imageUrl) => {
            zoomedImage.value = imageUrl;
            showZoom.value = true;
        };

        const closeZoom = () => {
            showZoom.value = false;
            zoomedImage.value = '';
        };

        const fetchResources = async () => {
            // Tableau temporaire pour stocker les ressources avec leur index
            const resourcesTemp = [];
            
            for (let i = 0; i < props.blockDatas.associatedResources.length; i++) {
                const resource = props.blockDatas.associatedResources[i];
                const url = `${process.env.VUE_APP_BASEURL}/s3Resource/${resource.name}`;
                
                try {
                    let response = await axios.get(url);
                    var imageUrl = response.data;
                    // Stocker l'URL de l'image avec son index
                    resourcesTemp.push({
                        url: imageUrl,
                        index: resource.index !== undefined ? resource.index : i
                    });
                } catch (error) {
                    console.error("Erreur lors de la récupération de l'image :", error);
                }
            }
            
            // Trier les ressources par index
            resourcesTemp.sort((a, b) => a.index - b.index);
            
            // Extraire uniquement les URLs des images triées
            resources.value = resourcesTemp.map(item => item.url);
        };

        const handleImageLoad = (event) => {
            const img = event.target;
            //const container = img.parentElement;
            
            // Calculer les dimensions de l'image
            const imgWidth = img.naturalWidth;
            const imgHeight = img.naturalHeight;
            const aspectRatio = imgWidth / imgHeight;
            
            // Dimensions du conteneur
            const containerWidth = 600;
            const containerHeight = 280;
            const containerAspectRatio = containerWidth / containerHeight;
            
            // Ajuster les dimensions selon l'orientation
            if (aspectRatio > containerAspectRatio) {
                // Image plus large que le conteneur (paysage)
                img.style.width = '100%';
                img.style.height = 'auto';
                img.style.maxHeight = '100%';
            } else {
                // Image plus haute que le conteneur (portrait)
                img.style.height = '100%';
                img.style.width = 'auto';
                img.style.maxWidth = '100%';
            }
            
            // Centrer l'image dans le conteneur
            img.style.objectFit = 'contain';
        };

    
        const initCarousel = () => {
            var carousel = document.querySelector(".carousel");
            var cells = carousel.querySelectorAll(".carousel__cell");
            var cellCount; // cellCount set from cells-range input value
            var selectedIndex = 0;
            var cellWidth = 750;
            var cellHeight = 350;
            var isHorizontal = true;
            var rotateFn = isHorizontal ? "rotateY" : "rotateX";
            var radius, theta;
            changeCarousel();

            function rotateCarousel() {
                var angle = theta * selectedIndex * -1;
                carousel.style.transform =
                    "translateZ(" + -radius + "px) " + rotateFn + "(" + angle + "deg)";
            }

            var prevButton = document.querySelector(".previous-button");
            prevButton.addEventListener("click", function () {
                selectedIndex--;
                rotateCarousel();
            });

            var nextButton = document.querySelector(".next-button");
            nextButton.addEventListener("click", function () {
                selectedIndex++;
                rotateCarousel();
            });

            function changeCarousel() {
                cellCount = document.querySelectorAll(".carousel__cell").length;
                theta = 360 / cellCount;
                var cellSize = isHorizontal ? cellWidth : cellHeight;
                radius = Math.round(cellSize / 2 / Math.tan(Math.PI / cellCount));
                for (var i = 0; i < cells.length; i++) {
                    var cell = cells[i];
                    if (i < cellCount) {
                        // visible cell
                        cell.style.opacity = 1;
                        var cellAngle = theta * i;
                        cell.style.transform =
                            rotateFn +
                            "(" +
                            cellAngle +
                            "deg) translateZ(" +
                            (radius + 220) +
                            "px)";
                    } else {
                        // hidden cell
                        cell.style.opacity = 0;
                        cell.style.transform = "none";
                    }
                }

                rotateCarousel();
            }
        };
        onMounted(() => {
            fetchResources();
            setTimeout(() => {
                initCarousel();
            }, 1000);

        })

        const { overlayBgStyle } = useOverlayBg();

        return {
            overlayBgStyle,
            resources,
            handleImageLoad,
            showZoom,
            zoomedImage,
            openZoom,
            closeZoom
        };
    },
};
</script>
<style  scoped>
@import url("https://fonts.googleapis.com/css2?family=Dongle&display=swap");

* {
    box-sizing: border-box;
}

body {
    text-align: center;
    background-color: #f1f2f3;
    font-family: "Dongle", sans-serif;
}

.container {
    background-color: rgba(217, 217, 217, 1);
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    top: 0;
    z-index: 9999;
    width: 100%;
  height: 100%;
}

.scene {
    margin: 40px 0;
    position: relative;
    width: 800px;
    height: 450px;
    margin: 60px auto;
    perspective: 1500px;
}

.carousel {
    width: 100%;
    height: 100%;
    position: absolute;
    transform: translateZ(-500px);
    transform-style: preserve-3d;
    transition: transform 1s;
}

.carousel__cell {
    position: absolute;
    width: 800px;
    height: 400px;
    left: 0px;
    top: 25px;
    text-align: center;
    transition: transform 1s, opacity 1s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.image-container {
    width: 750px;
    height: 350px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.1);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}



.carousel__cell:nth-child(1) {
    transform: rotateY(0deg) translateZ(700px);
}

.carousel__cell:nth-child(2) {
    transform: rotateY(40deg) translateZ(700px);
}

.carousel__cell:nth-child(3) {
    transform: rotateY(80deg) translateZ(700px);
}

.carousel__cell:nth-child(4) {
    transform: rotateY(120deg) translateZ(700px);
}

.carousel__cell:nth-child(5) {
    transform: rotateY(160deg) translateZ(700px);
}

.carousel__cell:nth-child(6) {
    transform: rotateY(200deg) translateZ(700px);
}

.carousel__cell:nth-child(7) {
    transform: rotateY(240deg) translateZ(700px);
}

.carousel__cell:nth-child(8) {
    transform: rotateY(280deg) translateZ(700px);
}

.carousel__cell:nth-child(9) {
    transform: rotateY(320deg) translateZ(700px);
}

img {
    border-radius: 10px;
    transition: all 0.3s ease;
    object-fit: contain;
    max-width: 100%;
    max-height: 100%;
}

.carousel-options {
    text-align: center;
    position: relative;
    z-index: 2;
    background: hsla(0, 0%, 100%, 0.8);
}

.content {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.footer {
    display: flex;
    position: absolute;
    bottom: 10px;
    width: 30%;
    justify-content: space-evenly;
    z-index: 99;
    color: black;
    font-size: 1.2rem;
    font-family: "Dongle", sans-serif;

}

.title {
    font-size: 4rem;
    margin: 5%;
    font-family: "Dongle", sans-serif;
}

.wave {
    position: absolute;
    bottom: 0;
}

.closeButtons{
   width: 20%;
   margin: auto;
}

/* Styles pour la modal de zoom */
.zoom-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    cursor: pointer;
}

.zoom-content {
    position: relative;
    max-width: 95%;
    max-height: 95%;
    cursor: default;
    display: flex;
    align-items: center;
    justify-content: center;
}

.zoomed-image {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    min-width: 800px;
    min-height: 600px;
    object-fit: contain;
    border-radius: 10px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

.close-zoom-btn {
    position: absolute;
    top: -10px;
    right: -10px;
    background-color: rgba(255, 255, 255, 0.9);
    color: #333;
    z-index: 10001;
}

</style>

